var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 0C132.969 52.5853 174.415 94.0314 227 113.5C174.415 132.969 132.969 174.415 113.5 227C94.0314 174.415 52.5853 132.969 0 113.5C52.5853 94.0314 94.0314 52.5853 113.5 0Z",
    fill: "url(#paint0_diamond_1926_746)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_1926_746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.5 113.5) rotate(89.7901) scale(136.501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE4C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99F59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGlow);
export default __webpack_public_path__ + "static/media/starGlow.19b40cffe43d8f710ff17cf57011e7bc.svg";
export { ForwardRef as ReactComponent };